import type { PropsWithChildren } from 'react'

import { Flex, Typography } from '@percent/lemonade'
import type { FormSubsectionProps } from './form-subsection.types'

export function FormSubsection({
  title,
  description,
  children,
}: Readonly<PropsWithChildren<FormSubsectionProps>>) {
  return (
    <Flex direction="column" gap="md">
      <Flex direction="column" gap={'0.5rem'}>
        <Typography variant="h4" $color="text_primary">
          {title}
        </Typography>
        <Typography variant="default" $color="gray600">
          {description}
        </Typography>
      </Flex>

      {children}
    </Flex>
  )
}
